import React, { useState, useEffect } from 'react';
import PageHeader from '../../../components/PageHeader/PageHeader';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import { API } from '../../../API/API';
import Can from '../../../components/Can/Can';

const CompanyList = (props) => {

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [columns] = useState([
        {
            name: 'Байгууллагын дугаар',
            fieldName: 'companyid',
            colSize: 'small'
        }, {
            name: 'Нэр',
            fieldName: 'companyname'
        }, {
            name: 'Байгууллагын регистр',
            fieldName: 'registerno'
        }, {
            name: 'Байгуулагдсан огноо',
            fieldName: 'registereddate'
        }
    ]);

    const getData = async () => {
        let tData = [];

        setLoading(true);
        await API.get('/api/humanresource/organization/get_company_list').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data.retdata) {
                    tData = response.data.retdata;
                }
            }
        });
        setLoading(false);
        setData(tData);
        setOData(tData);
    }

    useEffect(() => {
        getData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <PageHeader
                title={`Байгууллагын жагсаалт (${data.length})`}
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                loading={loading}
            />
            <GridDefaultShimmer
                setKey='companyid'
                loading={loading}
                columns={columns}
                data={data}
            />
        </div>
    );
}

export default CompanyList;